export default {
  diffusionInputs: 'Vstupy difúzie',
  partParameters: 'Parametre dielu',
  simulationValues: 'Hodnoty simulácie',
};
